<template>
    <!-- 右边主体[[ -->
    <div class="freelance">
        <!-- 文本内容弹窗start -->
        <!-- 敏感内容检测弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-sensitivity" style="display: block;" v-if="dirtyInfoDialog.show">
            <div class="popup-con sensitivity-popup">
                <div class="popup-close js-close-sensitivity"><i class="ico ico-close" @click="dirtyInfoDialog.show = false"></i></div>
                <h5 class="popup-title">敏感内容检测</h5>
                <div class="word">
                    标题中存在敏感词：<span class="color-theme">{{ dirtyInfoDialog.dirtyContent.title_dirty_words }}</span><br>
                    内容中存在敏感词：<span class="color-theme">{{ dirtyInfoDialog.dirtyContent.content_dirty_words}}</span>
                </div>
                <div class="pp-explain-inf g-scrollbar">
                    <div class="pp-explain-inf-con">
                        <div class="head">
                            <h4 class="name" v-html="dirtyInfoDialog.article.articleTitle"></h4>
                            <p class="author">{{ dirtyInfoDialog.article.creator}} <span class="time">{{ dirtyInfoDialog.article.created}}</span></p>
                        </div>
                        <p class="popup-text" v-html="dirtyInfoDialog.article.articleContent"></p>
                    </div>
                </div>
            </div>
            <!-- 敏感内容检测弹窗end -->
        </div>

        <!-- 驳回弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-reject" style="display: block;" v-if="rejectDialog.show">
            <div class="popup-con reject-popup">
                <div class="popup-close js-close-reject"><i class="ico ico-close"  @click="cancelReject"></i></div>
                <h5 class="popup-title">驳回理由</h5>
                <textarea class="textarea" name="" cols="" rows="6" placeholder="请输入驳回理由" v-model="rejectDialog.reason"></textarea>
                <p class="btn">
                    <a class="g-btn js-close-reject" href="javascript:;" @click="doRejectArticle">提交</a>
                    <a class="g-btn js-close-reject" href="javascript:;" @click="cancelReject">取消</a>
                </p>
            </div>
            <!-- 驳回弹窗end -->
        </div>


        <div class="g-content">
            <div class="g-status">
                <a class="arrow-left js-status-left" href="#" @click="swiperPrev"><i class="ico ico-arrow-left"></i></a>
                <a class="arrow-right js-status-right" href="#" @click="swiperNext"><i class="ico ico-arrow-right"></i></a>
                <div class="swiper-container" id="swiper-tab">
                    <div class="swiper-wrapper">
                        <!-- 交互说明：
                            选中样式：给p标签添加类 active
                         -->
                        <div class="swiper-slide" v-for="(item,index) in swiperItem" :key="item.id">
                            <div class="title" :class="{active: index == curTab}" @click="changeTab(index,item)">{{item.name}}<span class="num">（{{item.num}}）</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search f-clearfix">
                <select-box :selectList="allGame" :itemTitle="'游戏'" :selected.sync="params.gameId"></select-box>
                <select-box :selectList="allTask" :itemTitle="'任务名称'" :selected.sync="params.missionId"></select-box>
                <select-box :selectList="articleType" :itemTitle="'内容类型'" :selected.sync="params.type"></select-box>
                <div class="list contribute-time">
                    <p class="name">投稿时间</p>
                    <div class="g-select f-fl">
                        <el-date-picker
                                style="width:200px;"
                                v-model="dateVal"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                format="yy/MM/dd"
                                value-format="yyyy-MM-dd"
                                @change="onDateChange"
                        >
                        </el-date-picker>
                        <div class="picker-box">

                        </div>
                    </div>
                </div>
                <div class="list" style="margin-top: 3px;">
                    <p class="name"><label for="keyword">内容标题</label></p>
                    <div class="g-select f-fl">
                        <input class="input" name="keyword" type="text" placeholder="请输入内容标题" v-model="params.title">
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="getList">
                </div>
            </div>
            <ul class="freelance-list">
                <li class="list-empty f-clearfix" v-if="count == 0">
                    <img src="~Assets/img/pages/v4/search-null.png"/>
                </li>
                <li class="list f-clearfix" v-for="article in articleList" :key="article.id">
                    <div class="f-clearfix">
                        <p class="pic"><img :src="article.cover" width="197" height="111" alt=""></p>
                        <div class="txt">
                            <!-- 交互说明：
                                文本内容弹窗：js-open-view
                                视频内容弹窗：js-open-view-video
                             -->
                            <h3 class="title"><span class="type">{{ getArticleType(article) }}</span>
                                <a class="name js-open-view" href="javascript:;" @click="previewArticle(article)">{{ article.articleTitle }}</a>
                                <span class="btn" v-show="article.isOriginal == 1">原创</span>
                            </h3>
                            <div class="intro">
                                {{ article.gameName }}
                            </div>
                            <p class="author">{{ article.creator }} <span class="time">{{ article.created ?  article.created.substr(0,10) : '' }}</span>
                            </p>
                        </div>
                        <div class="examine">
                            <p class="data">
                                <label class="label"></label>
                                <a class="link js-open-similarity" href="javascript:;"></a>
                                <!-- 交互说明：
                                    文本内容相似度弹窗：js-open-similarity
                                    视频内容相似度弹窗：js-open-video
                                 -->
                            </p>
                            <p class="data">
                                <label class="label">敏感词</label>
                                <a class="link js-open-sensitivity" href="javascript:;" @click="showDirtyInfoDialog(article)">{{ article.dirtyCheck.checkStatusText }}</a>
                            </p>

                        </div>
                        <div class="operation">
                            <div v-if="article.articleStatus == 10">
                                <p class="status">
                                <span>
                                    {{ getArticleStatusText(article.articleStatus)}}
                                </span>
                                </p>
                                <p class="btn">
                                    <!--供应商的验收操作-->
                                    <a class="g-btn" href="javascript:;" @click="publishArticle(article)">通过</a>
                                    <a class="g-btn js-open-reject" href="javascript:;" @click="rejectArticle(article)">驳回</a>
                                </p>
                            </div>
                            <div v-else-if="[18,20].includes(article.articleStatus)">
                                <p class="status status-pass">
                                <span>
                                    {{ getArticleStatusText(article.articleStatus)}}
                                </span>
                                </p>
                            </div>
                            <div v-else-if="[50].includes(article.articleStatus)">
                                <p class="status">
                                <span>
                                    {{ getArticleStatusText(article.articleStatus)}}
                                </span>
                                </p>
                                <div class="reject">
                                    <p class="info f-hide-col-4">{{ article.reject_remark }}</p>
                                    <p class="all"><i class="triangle"></i>{{ article.reject_remark }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <pagination
                v-if="count>0"
                :total="count"
                :page-size="params.pageSize"
                @change="pageChange"
                ref="pager">
            </pagination>
        </div>

        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <!--内容预览 end-->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/vendor/swiper/swiper-3.2.7.min.css';
    @import '~Assets/sass/pages/v4/check/freelance.scss';
    .picker-box{
        height: 40px;
        display: inline-block;
        vertical-align: bottom;
        // width: 450px;
        /deep/ .full-jcalendar .input__inner{
            height: 40px;
            border: 0;
            border-bottom: 1px solid #EBEBEB;
            &::-webkit-input-placeholder{
                font-weight: normal ;
                font-size: 14px;
            }
        }
    }
    .g-content{min-height: 50rem}
    .freelance .freelance-list .channel .name{width: 110px}
    .freelance .freelance-list .channel .item{margin-bottom: 3px}
    .freelance .freelance-list .examine .label{width: 90px}
    .color-theme{color: #FD7E28;}
    .list-empty{
        width: 100%;
        text-align: center;
        height: 300px;
        margin-top: 50px;
    }

</style>
<script>
import Swiper from 'Assets/vendor/swiper/swiper-3.2.7.min.js';
import pagination from 'Components/v4/pagination/pagination_v4';
import selectBox from 'Components/v4/dropdown/select_box';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    AllGame, TaskVerifyList, TaskVerifyStatus, TaskVerifyPass, TaskVerifyRject, ArticleDetail, TaskAll
} from 'Services/getData.js';
export default {
    data() {
        return {
            	articleList: [],
            datePicker: {
                value: '',
                type: 'DATERANGE',
                showLunarClass: 'MIX',
                showBackYears: 2,
                showLunarico: false,
                showLunarControl: false,
                width1: '200',
                height: '40',
                format: 'YYYY.MM.DD',
                placeholder: '请输入日期',
                rangeSeparator: '-',
                disabled: false,
                editable: true,
                clearable: true,
                pickerOptions: {
                    disabledDate (time) {
                        return time.getTime() > Date.now();
                    }
                }
            },
	            dateVal: [],
	            pickerOptions: {
		            disabledDate (time) {
			            return time.getTime() > Date.now(); //这里就是设置当天后的日期不能被点击
		            }
	            },
            swiperItem: [
                {
                    name: '待审核', id: 10, num: 0 
                },
                {
                    name: '供应商已通过', id: 18, num: 0 
                },
                {
                    name: '已通过', id: 20, num: 0 
                },
                {
                    name: '发布中', id: 25, num: 0 
                },
                {
                    name: '已发布', id: 30, num: 0 
                },
                {
                    name: '已驳回', id: 50, num: 0 
                }
            ], /*0非计费内容 1待达标 2未验收 3供应商验收通过 4供应商验收驳回 5内容经理验收通过 6内容经理验收驳回 7未达标*/
            mySwiper: '',
            curTab: 0,
            curTabId: 10,
            count: 0, //总记录数
            params: {
                pageSize: 10,
                pageIndex: 0,
	                gameId: '',
	                type: '',
                title: '',
                created: '' // 投稿时间
            },
	            allGame: [],
	            articleType: [
		            {
                    name: '请选择', id: '' 
                },
		            {
                    name: "图文", id: 0 
                },
		            {
                    name: "视频", id: 1 
                },
		            {
                    name: "小说", id: 50 
                },
		            {
                    name: "漫画", id: 60 
                }
	            ],
	            mediaDistributeDialog: {
                	show: false,
		            outTitle: '',
		            outCover: '',
		            accountName: '',
		            mediaName: ''
            },
            rejectDialog: {
                	articleId: '',
                	show: false,
                reason: ''
            },
            dirtyInfoDialog: {
                	show: false,
	                dirtyContent: {},
                article: {}
            },
            allTask: []
        }
    },
    components: {
        pagination, selectBox, contentPreview, videoPreview
    },
    mounted(){
        this.initSwiper();
	        this.getAllGame();
        this.getList();
        this.getTaskAll();
    },
    filters: {},
    methods: {
        	getList(){
		        this.getArticleList();
		        this.getArticleListStat();
        },
        changeTab(index, tabItem){
            this.curTab = index;
	            this.curTabId = tabItem.id;
            this.getArticleList();
	            this.getArticleListStat();
        },
        onDateChange(choiceDate){
            // this.property.beginTime = choiceDate[0];
            // this.property.endTime = choiceDate[1];
        },
        initSwiper(){
            this.mySwiper = new Swiper('#swiper-tab', {
	                paginationClickable: true,
	                slidesPerView: 'auto',
	                initialSlide: 0,
	                slideToClickedSlide: true,
	                centeredSlides: true,
	                onTransitionEnd: function(swiper){
		                if(swiper.progress == 1){
			                swiper.activeIndex = swiper.slides.length-1
		                }
	                }
            })
        },
        async getTaskAll() {
            let ret = await TaskAll();
            if(ret.status == 200 && ret.data.code == 0){
                this.allTask = ret.data.data.map((item)=> { return {
                    id: item.id, name: item.title
                }});
                this.allTask.splice(0, 0, {
                    id: '', name: '全部'
                });
            }
        },
        swiperPrev(){
            this.mySwiper.slidePrev();
        },
        swiperNext(){
            this.mySwiper.slideNext();
        },
	        showMediaDistributeDialog(media){
		        this.mediaDistributeDialog = Object.assign({}, media, {
                show: true
            });
        },
        publishArticle(article){
	            this.$confirm('确认审核通过此内容').then(()=>{
		            this.doPublishArticle(article.id);
            }).catch(() => {});
        },
        previewArticle(article){
            if(article.articleType === 0){
	                this.$refs.contentPreview.loadInfo(article.id);
            }else{
	                this.$refs.videoPreview.remotePreview(article.id);
            }
        },
        rejectArticle(article){
	            this.rejectDialog.show = true;
	            this.rejectDialog.articleId = article.id;
        },
        cancelReject(){
	            this.rejectDialog = {
	            	show: false,
                articleId: '',
                reason: ''
            };
        },
	        showDirtyInfoDialog(article){
		        this.dirtyInfoDialog.show = true;
		        this.dirtyInfoDialog.dirtyContent = article.dirtyContent;
		        this.getArticleDetail(article.id);
	        },
        async getArticleDetail(id){
	            let response = await ArticleDetail(id);
	            let result = response.data;
	            if(response.status && result.code == 0){
		            let article = result.data;
		            let dirtyContent = this.dirtyInfoDialog.dirtyContent;
                let tDirtyWord =dirtyContent.title_dirty_words && dirtyContent.title_dirty_words.split(',');
		            let cDirtyWord = dirtyContent.content_dirty_words && dirtyContent.content_dirty_words.split(',');
		            article.articleContent = article.articleContent && article.articleContent.replace(new RegExp(`(${cDirtyWord.join('|')})`, 'g'),
			            `<span style="color: #FD7E28">$1</span>`);
		            article.articleTitle = article.articleTitle && article.articleTitle.replace(new RegExp(`(${tDirtyWord.join('|')})`, 'g'),
			            `<span style="color: #FD7E28">$1</span>`);
		            this.dirtyInfoDialog.article = article;
	            }
        },
	        async doPublishArticle(id){
		        let param = {
                articleId: id
            };
		        let res = await TaskVerifyPass(param);
		        if(res.status == 200 && res.data.code == 0){
			        this.$alert('操作成功');
			        this.getList();
		        }
        },
	        async doRejectArticle(){
        		if(!this.rejectDialog.reason){
			        alert('驳回原因不能为空~');
			        return false;
            }
		        this.rejectDialog.show = false;
		        let param = this.rejectDialog;
		        let res = await TaskVerifyRject(param);
		        if(res.status == 200 && res.data.code == 0){
			        this.$alert('操作成功');
			        this.getList();
            }
        },
        async getArticleList(){
	            let queryTime = {};
            if(typeof this.dateVal != null){
	                 queryTime = {
		                startTime: this.dateVal[0],
		                 endTime: this.dateVal[1]
	                };
            }
	            let param = Object.assign(this.params, {
                status: this.curTabId 
            }, queryTime);
	            let res = await TaskVerifyList(param);
            let data = res.data;
	            if(res.status == 200 && res.data.code == 0){
		            this.articleList = data.data.articles.map((article)=>{
			            article.showMediaDistribute = false;
			            return article;
                });
                this.count = data.data.total;
	            }
        },
	        async getArticleListStat(){
		        let res = await TaskVerifyStatus();
		        if(res.status == 200 && res.data.code == 0){
                let data = res.data.data;
                let statusMap = data.map((item)=>{
                    let map = [];
                    map[item.status] = item.total;
                    return map;
                });
			        this.swiperItem.filter((item) => {
                    data.filter((status)=>{
                        if (status.status == item.id) {
                            item.num = status.num;
                        }
                    });
				        return item;
			        });
            }
        },

        pageChange (param) {
            this.params.pageIndex = param.pageIndex-1;
            this.getList();
        },
	        async getAllGame(){
		        let res = await AllGame();
		        if(res.status == 200 && res.data.code == 0){
                this.allGame = res.data.data;
                this.allGame.splice(0, 0, {
                    name: '全部', id: ''
                })
		        }
	        },
        getArticleStatusText(articleStatus){
	            let text = '';
	            this.swiperItem.filter((item)=>{
	            	if(item.id == articleStatus){
			            text = item.name;
                }
            })
	            return text;
        },
	        getArticleType(item){
		        let type = ''
		        switch(parseInt(item.articleType)){
			        case 0:
				        type = '图文';
				        break;
			        case 1:
				        type = '视频';
				        break;
			        case 50:
				        type = '小说';
				        break;
			        case 60:
				        type = '漫画';
				        break;
			        default:
				        type = '其他';
				        break;
		        }
		        return `【${type}】`;
	        }
    }
}
</script>
